import React, { useState } from "react";
import { FiMessageCircle, FiX } from "react-icons/fi";
import { FaRobot } from "react-icons/fa";
import "../Styles/FloatingContactButtons.css";

function ChatBotIcon() {
    const [open, setOpen] = useState(false);

    return (
        <>
            {/* Chat Icon */}
            <div className="chatbot-icon" onClick={() => setOpen(!open)}>
                <FaRobot size={26} />
            </div>

            {/* Chat Window */}
            {open && (
                <div className="chatbot-window">
                    <div className="chatbot-header">
                        <span>AI Assistant</span>

                        <FiX
                            size={18}
                            style={{ cursor: "pointer" }}
                            onClick={() => setOpen(false)}
                        />
                    </div>

                    <div className="chatbot-body">
                        <p><FaRobot /> AI Chatbot coming soon...</p>
                    </div>
                </div>
            )}
        </>
    );
}

export default ChatBotIcon;